import { fakeBackendProvider } from './shared/providers/fake-backend';
import {BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import * as Hammer from 'hammerjs';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

import {AppComponent} from './app.component';
import {MobileRoutingModule} from './mobile-routing.module';

// Modules
import { SharedModule } from './shared/shared.module';

import { initializeAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, indexedDBLocalPersistence } from 'firebase/auth';

import { provideFirebaseApp } from '@angular/fire/app';
import { getApp, getApps, initializeApp } from 'firebase/app';

import { environment } from 'src/environments/environment';
import { RollbarErrorHandler, RollbarService, rollbarFactory } from './shared/providers/rollbarlog.service';
import { WebRoutingModule } from './web-routing.module';
import { WebModule } from './web.module';
import { MobileModule } from './mobile.module';

import { Capacitor } from '@capacitor/core';
import { DialogService } from './shared/providers/dialog.service';
import { MobileDialogService } from './shared/providers/dialog-mobile.service';
import { WebDialogService } from './shared/providers/dialog-web.service';


let resolvePersistenceEnabled: (enabled: boolean) => void;

export const persistenceEnabled = new Promise<boolean>(resolve => {
  resolvePersistenceEnabled = resolve;
});

declare global {
    interface Window {
    Intercom: any;
  }
}

class HammerConfig extends HammerGestureConfig {
  public events = ['swipe','press','tap','doubletap']
  public overrides = {
    'swipe': {direction: Hammer.DIRECTION_VERTICAL },
    'press': {time: 250},  // default: 251 ms
    'tap': {interval: 400, time: 350},
    'doubletap' : {requireFailure: 'tap'}
    // 'pan': {direction: Hammer.DIRECTION_HORIZONTAL},
  } as any;
  public options = {
    touchAction: 'auto'
  }
}

@NgModule({
    declarations: [
        AppComponent,

    ],
    imports: [
        BrowserModule,
        SharedModule,
        environment.type === 'mobile' ? MobileRoutingModule : WebRoutingModule,
        environment.type === 'web' ? WebModule : MobileModule,
        HammerModule,
        NgxPageScrollCoreModule,
        // AngularFireModule.initializeApp(environment.firebaseConfig),
        // AngularFireAuthModule,
        // AngularFirestoreModule,
        // Custom modules
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideFirestore(() => getFirestore()),
        provideAuth(() => {
            if (Capacitor.isNativePlatform()) {
                return initializeAuth(getApp(), {
                    persistence: indexedDBLocalPersistence
                });
            } else {
                return getAuth();
            }
        })
    ],
    providers: environment.rollbarFullLogEnabled ?
        [
            { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
            { provide: ErrorHandler, useClass: RollbarErrorHandler },
            { provide: RollbarService, useFactory: rollbarFactory },
            { provide: DialogService, useFactory: dialogServiceFactory, deps: [WebDialogService, MobileDialogService]},
        ] :
        [
            { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
            { provide: RollbarService, useFactory: rollbarFactory },
            { provide: DialogService, useFactory: dialogServiceFactory, deps: [WebDialogService, MobileDialogService]},
            fakeBackendProvider
        ],
    bootstrap: [AppComponent]
})

export class AppModule {
}

export function dialogServiceFactory(
  webDialogService: WebDialogService,
  mobileDialogService: MobileDialogService
): DialogService {
  return environment.type === 'web' ? webDialogService : mobileDialogService;
}
